(function () {
  if (window.__cardProductVideoBound) return;
  window.__cardProductVideoBound = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function getCard(target) {
    if (!target || !target.closest) return null;
    return target.closest('.product-card-wrapper');
  }

  function ensureSources(video) {
    if (video.dataset.loaded === 'true') return Promise.resolve();

    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
    });

    video.dataset.loaded = 'true';
    video.load();

    return new Promise(function (resolve) {
      if (video.readyState >= 2) {
        resolve();
        return;
      }
      var onReady = function () {
        video.removeEventListener('loadeddata', onReady);
        resolve();
      };
      video.addEventListener('loadeddata', onReady);
    });
  }

  function playCardVideo(card) {
    if (!card || reduceMotion.matches || !canHover.matches) return;
    var video = card.querySelector('video.card__video');
    if (!video) return;

    ensureSources(video).then(function () {
      if (!card.matches(':hover') && !card.matches(':focus-within')) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            card.classList.add('is-video-playing');
          })
          .catch(function () {});
      } else {
        card.classList.add('is-video-playing');
      }
    });
  }

  function pauseCardVideo(card) {
    if (!card) return;
    var video = card.querySelector('video.card__video');
    if (!video) return;
    video.pause();
    card.classList.remove('is-video-playing');
  }

  document.addEventListener('mouseover', function (event) {
    var card = getCard(event.target);
    if (!card || !card.querySelector('video.card__video')) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    playCardVideo(card);
  });

  document.addEventListener('mouseout', function (event) {
    var card = getCard(event.target);
    if (!card || !card.querySelector('video.card__video')) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    pauseCardVideo(card);
  });

  document.addEventListener('focusin', function (event) {
    var card = getCard(event.target);
    if (!card || !card.querySelector('video.card__video')) return;
    playCardVideo(card);
  });

  document.addEventListener('focusout', function (event) {
    var card = getCard(event.target);
    if (!card || !card.querySelector('video.card__video')) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    pauseCardVideo(card);
  });
})();
